<div class="documents-container">
  <div><h4 *ngIf="documents && documents.length > 0" translate>{{title}}</h4></div>
  <div class="box-list-item" *ngFor="let doc of documents">
    <span class="float-start iconClass se-icons">action_pdf_report</span>
    <span>{{doc.description}}</span>
    <a class="float-end" target="_blank" href="{{doc.downloadUrl}}"><span class="se-icons download-icon">action_download</span></a>
  </div>
</div>
